import React from "react";
import { FormattedMessage } from "react-intl";
import { Stack, Text } from "@chakra-ui/react";
import { CurrencyInput } from "components/Form";

/**
 * Component for entering the payout amount.
 * @param {Object} props - Component props.
 * @param {string} props.currency - The currency.
 * @param {boolean} props.isDisabled - Whether the input is disabled.
 * @param {string|null} props.error - Error message, if any.
 * @returns {JSX.Element} PayoutAmountInput component.
 */
const PayoutAmountInput = ({ currency, isDisabled, error }) => {
  return (
    <Stack spacing="6" textAlign="center" m="40px auto 30px" w="245px">
      <Text fontSize="lg" fontWeight="500">
        <FormattedMessage
          defaultMessage="Payout Amount <bold>(currency type)</bold>"
          description="Input label. (currency type) is a placeholder and doesn't require traslation"
          values={{
            bold: () => (
              <Text as="span" fontSize="md" fontWeight="400">
                ({currency})
              </Text>
            ),
          }}
        />
      </Text>
      <CurrencyInput
        name="amount"
        variant="flushed"
        fontSize="4xl"
        textAlign="center"
        error={error}
        currency={currency}
        disabled={isDisabled}
      />
    </Stack>
  );
};

export default PayoutAmountInput;
